// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"3cef8317","121":"4524bf39","205":"d003efa6","417":"93ced934","446":"7f37e26d","488":"eadfa0b8","550":"79b0949f","653":"a7a90fa7","827":"c1cd2f1f","835":"a2bbc17a"}[chunkId] + ".chunk.js";
};